import tw from "twin.macro";

export const SectionHeading = tw.h2`text-4xl sm:text-5xl font-bold text-center text-white`
export const Subheading = tw.h5`font-bold text-white`
